/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { Input } from "antd";
import Cookies from "js-cookie";
import Api from "../../../../services/ServiceApi";
import Map from "../../mapcomponent";
import Modalselectsite from "./ModalSiteCodeSelect";

const { Search } = Input;
const content = {
  siteid: {
    label: "Site ID",
    value: "",
  },
  sitegrade: {
    label: "Site Grade",
    value: "",
  },
  sitename: {
    label: "Site Name",
    value: "",
  },
  latitude: {
    label: "Latitude",
    value: "",
  },
  longtitude: {
    label: "Longtitude",
    value: "",
  },
};

export default function Stopstation({
  title,
  formdata,
  valuechange,
  language,
  factupdate,
  latitude,
  longtitude,
  areacode,
  setformdata,
}) {
  const locale = Cookies.get("locale");
  const [ModalShow, setModalShow] = useState(false);
  const [inputSite, setinputSite] = useState("");
  async function OnSearch(Textinput) {
    setinputSite(Textinput);
    await setModalShow(true);
  }
  const autoAssingSite = async (
    siteCode,
    siteName,
    gradeSite,
    latitude,
    longitude
  ) => {
    setformdata((FormData) => ({
      ...FormData,
      stopsiteid: siteCode,
      stopsitename: siteName,
      stopsitegrade: gradeSite,
      stoptsitelatitude: latitude || 0,
      stoptsitelongtitude: longitude || 0,
    }));
    await setModalShow(false);
  };
  return (
    <>
      <div
        className="col-lg-4 mt-4 pb-5 mr-4 ml-4"
        style={{ backgroundColor: "#FFFFFF", borderRadius: "5px" }}
      >
        <div className="row pr-5 mt-3">
          <img
            src={Api.absoluteUrl(`/icon/bbtec/body/original-station.svg`)}
            alt={title}
            title={title}
            className="mr-2 mb-1"
          />
          <span className="font-thai-b fs-22">{title}</span>
        </div>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col col-12">
            <div className="row">
              <div className="col col-12">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="row">
                      <span className="font-thai-r c-gray fs-18">
                        {factupdate
                          ? language[locale]["search_site"]
                          : content.siteid.label}
                      </span>
                    </div>
                    <div className="row">
                      <Search
                        disabled={formdata.IsHold || false}
                        placeholder="Input site code"
                        enterButton
                        onSearch={OnSearch}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="row">
                      <span className="font-thai-r c-gray fs-18">
                        {factupdate
                          ? language[locale]["site_id"]
                          : content.siteid.label}
                      </span>
                    </div>
                    <div className="row">
                      <Input
                        disabled={formdata.IsHold || false}
                        name="stopsiteid"
                        className="inputfile c-blue"
                        value={formdata.stopsiteid}
                        onChange={valuechange}
                      ></Input>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="row">
                      <span className="font-thai-r c-gray fs-18">
                        {factupdate
                          ? language[locale]["site_name"]
                          : content.sitename.label}
                      </span>
                    </div>
                    <div className="row">
                      <Input
                        disabled={formdata.IsHold || false}
                        name="stopsitename"
                        className="inputfile c-blue"
                        value={formdata.stopsitename}
                        onChange={valuechange}
                      ></Input>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="row">
                      <span className="font-thai-r c-gray fs-18">
                        {factupdate
                          ? language[locale]["site_grade"]
                          : content.sitegrade.label}
                      </span>
                    </div>
                    <div className="row">
                      <Input
                        disabled={formdata.IsHold || false}
                        name="stopsitegrade"
                        className="inputfile c-blue"
                        value={formdata.stopsitegrade}
                        onChange={valuechange}
                      ></Input>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="row">
                      <span className="font-thai-r c-gray fs-18">
                        {factupdate
                          ? language[locale]["location_lat"]
                          : content.latitude.label}
                      </span>
                    </div>
                    <div className="row">
                      <Input
                        disabled={formdata.IsHold || false}
                        name="stoptsitelatitude"
                        className="inputfile c-blue"
                        value={formdata.stoptsitelatitude}
                        onChange={valuechange}
                      ></Input>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <span className="font-thai-r c-gray fs-18">
                        {factupdate
                          ? language[locale]["location_lon"]
                          : content.longtitude.label}
                      </span>
                    </div>
                    <div className="row">
                      <Input
                        disabled={formdata.IsHold || false}
                        name="stoptsitelongtitude"
                        className="inputfile c-blue"
                        value={formdata.stoptsitelongtitude}
                        onChange={valuechange}
                      ></Input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row d-flex justify-content-center align-items-center">
          <div
            className="position-relative mt-4 mr-2 ml-2"
            style={{ height: "230px", width: "100%" }}
          >
            {latitude &&
            longtitude &&
            Number(latitude) > 0 &&
            Number(longtitude) > 0 ? (
              <Map
                center={{
                  lat: Number(latitude),
                  lng: Number(longtitude),
                }}
                zoom={13}
              ></Map>
            ) : (
              <span className="font-thai-r fs-18 mx-auto ml-3 text-center font-italic c-gray">
                ไม่สามารถเรียก MAP ได้เนื่องจาก Location ไม่ถูกต้อง
              </span>
            )}
          </div>
        </div>
      </div>
      {ModalShow ? (
        <Modalselectsite
          areacode={areacode}
          inputSite={inputSite}
          ModalShow={ModalShow}
          setModalShow={setModalShow}
          autoAssingSite={autoAssingSite}
        ></Modalselectsite>
      ) : null}
    </>
  );
}
